import script from "./SignUpComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpComplete.vue?vue&type=script&setup=true&lang=js"

import "./SignUpComplete.vue?vue&type=style&index=0&id=6ef4119c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ef4119c"]])

export default __exports__